(() => {
  if (!document.body.classList.contains('cv-home')) return;
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  function install(component) {
    if (component.dataset.cvHomeReady) return;
    const track = component.querySelector('.product-grid');
    const controls = component.querySelector('.slider-buttons');
    if (!track) return;
    component.dataset.cvHomeReady = 'true';
    const columns = track.className.match(/grid--(\d+)-col-desktop/);
    if (columns) component.style.setProperty('--cv-home-columns',columns[1]);
    const prev = controls?.querySelector('[name="previous"]');
    const next = controls?.querySelector('[name="next"]');
    controls?.querySelector('.slider-counter')?.setAttribute('aria-hidden','true');
    const progress = document.createElement('div');
    progress.className = 'cv-home-progress';
    progress.setAttribute('role','progressbar');
    progress.setAttribute('aria-valuemin','0');
    progress.setAttribute('aria-valuemax','100');
    progress.setAttribute('aria-controls',track.id);
    progress.setAttribute('aria-label',component.closest('.collection')?.querySelector('.title')?.textContent.trim() || track.getAttribute('aria-label') || document.title);
    component.append(progress);
    let items = [], offsets = [0], current = 0, frame, gesture = null, suppressClick = false;
    const left = item => item.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    const maxScroll = () => Math.max(0,track.scrollWidth - track.clientWidth);
    const move = index => track.scrollTo({left:offsets[Math.max(0,Math.min(index,offsets.length - 1))],behavior:motion()});
    function sync() {
      const max = maxScroll();
      current = offsets.reduce((best,offset,index) => Math.abs(offset - track.scrollLeft) < Math.abs(offsets[best] - track.scrollLeft) ? index : best,0);
      if (controls) controls.hidden = max < 3;
      if (prev) prev.disabled = track.scrollLeft < 3;
      if (next) next.disabled = track.scrollLeft > max - 3;
      const position = Math.max(0,Math.min(1,track.scrollLeft / Math.max(1,max)));
      const size = Math.min(1,track.clientWidth / Math.max(1,track.scrollWidth));
      progress.hidden = max < 3;
      progress.style.setProperty('--cv-home-progress-size',(size * 100) + '%');
      progress.style.setProperty('--cv-home-progress-offset',(position * (1 - size) * 100) + '%');
      progress.setAttribute('aria-valuenow',String(Math.round(position * 100)));
    }
    function rebuild() {
      items = [...track.children].filter(item => item.getBoundingClientRect().width > 0);
      const max = maxScroll();
      offsets = [...new Set([0,...items.map(item => Math.round(Math.max(0,Math.min(max,left(item))))),max])];
      const image = items[0]?.querySelector('.card__inner');
      if (image) component.style.setProperty('--cv-home-arrow-top',(image.getBoundingClientRect().top - component.getBoundingClientRect().top + image.getBoundingClientRect().height / 2) + 'px');
      sync();
    }
    for (const item of track.children) {
      if (item.querySelector(':scope > .cv-home-color-slot')) continue;
      const slot = document.createElement('div');
      slot.className = 'cv-home-color-slot';
      slot.dataset.cvColorSlot = '';
      const card = item.querySelector('[data-product-id]');
      if (card) slot.dataset.productId = card.dataset.productId;
      item.append(slot);
    }
    for (const [button,direction] of [[prev,-1],[next,1]]) button?.addEventListener('click',event => {
      event.preventDefault(); event.stopImmediatePropagation(); sync(); move(current + direction);
    },true);
    track.addEventListener('scroll',() => { cancelAnimationFrame(frame); frame = requestAnimationFrame(sync); },{passive:true});
    track.addEventListener('dragstart',event => event.preventDefault());
    track.addEventListener('pointerdown',event => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.target.closest('button,input,select,textarea')) return;
      suppressClick = false;
      gesture = {id:event.pointerId,x:event.clientX,y:event.clientY,left:track.scrollLeft,dragging:false};
    });
    track.addEventListener('pointermove',event => {
      if (!gesture || gesture.id !== event.pointerId) return;
      const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
      if (!gesture.dragging) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        if (Math.abs(dy) > Math.abs(dx)) { gesture = null; return; }
        gesture.dragging = true; track.classList.add('cv-home-dragging'); track.setPointerCapture(event.pointerId);
      }
      event.preventDefault(); track.scrollLeft = gesture.left - dx;
    });
    function finish(event) {
      if (!gesture || gesture.id !== event.pointerId) return;
      const saved = gesture; gesture = null;
      if (track.hasPointerCapture(saved.id)) track.releasePointerCapture(saved.id);
      if (!saved.dragging) return;
      suppressClick = true; track.classList.remove('cv-home-dragging'); sync(); move(current);
    }
    ['pointerup','pointercancel','lostpointercapture'].forEach(type => track.addEventListener(type,finish));
    track.addEventListener('click',event => {
      if (!suppressClick || event.detail === 0) return;
      event.preventDefault(); event.stopImmediatePropagation(); suppressClick = false;
    },true);
    new ResizeObserver(rebuild).observe(track);
    new MutationObserver(rebuild).observe(track,{childList:true});
    rebuild();
  }
  const scan = root => {
    if (root.matches?.('.collection slider-component')) install(root);
    root.querySelectorAll?.('.collection slider-component').forEach(install);
  };
  scan(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) scan(node);
  }))).observe(document.querySelector('#MainContent'),{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',event => scan(event.target));
})();

